// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddVendorUserRequest
 */
export interface AddVendorUserRequest {
    /**
     * 
     * @type {string}
     * @memberof AddVendorUserRequest
     */
    email: string;
}

/**
 * Check if a given object implements the AddVendorUserRequest interface.
 */
export function instanceOfAddVendorUserRequest(value: object): value is AddVendorUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AddVendorUserRequestFromJSON(json: any): AddVendorUserRequest {
    return AddVendorUserRequestFromJSONTyped(json, false);
}

export function AddVendorUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddVendorUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function AddVendorUserRequestToJSON(json: any): AddVendorUserRequest {
    return AddVendorUserRequestToJSONTyped(json, false);
}

export function AddVendorUserRequestToJSONTyped(value?: AddVendorUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}
